import MemoryList from "./MemoryList";
export default function MemoryTabPadroes() {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Padrões que se repetiram o suficiente para virar referência. Esquecem devagar.
      </p>
      <MemoryList layers={["semantic", "factual"]} emptyHint="Ainda sem padrões. Quando assuntos se repetirem, eles aparecem aqui." />
    </div>
  );
}
